/**
 * Demo Authentication Utilities
 * For development/testing without Firebase configuration
 */

// Demo mode flag - set to false when you have Firebase configured
export const DEMO_MODE = true;

// Valid demo credentials
export const DEMO_CREDENTIALS = {
  registerNumber: '12345',
  otp: '123456',
};

/**
 * Simulate sending OTP in demo mode
 * @param {string} registerNumber - The register number
 * @returns {Promise<boolean>}
 */
export const sendDemoOTP = async (registerNumber) => {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 1000));
  
  if (registerNumber === DEMO_CREDENTIALS.registerNumber) {
    console.log('Demo OTP sent. Use: 123456');
    return true;
  }
  
  throw new Error('Invalid register number');
};

/**
 * Simulate OTP verification in demo mode
 * @param {string} otp - The OTP code
 * @returns {Promise<object>}
 */
export const verifyDemoOTP = async (otp) => {
  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 1500));
  
  if (otp === DEMO_CREDENTIALS.otp) {
    return {
      user: {
        uid: 'demo-user-123',
        phoneNumber: '+1234567890',
        displayName: 'Demo User',
      },
    };
  }
  
  throw new Error('Invalid OTP code');
};

export default {
  DEMO_MODE,
  DEMO_CREDENTIALS,
  sendDemoOTP,
  verifyDemoOTP,
};



